import service from '../request/index'


// 获取层级
export function getAreaDict (data) {
  return service({
    url: '/api/open/getAreaDict',
    method: 'GET',
    params: data,
  })
}


// 发布/编辑文档
export function publishDocument (data) {
  return service({
    url: '/es/resource/lib/publish/document',
    method: 'POST',
    data: data,
  })
}

// 发布/编辑微课
export function publishCourse (data) {
  return service({
    url: '/es/resource/lib/publish/minute_course',
    method: 'POST',
    data: data,
  })
}

// 编辑详情
export function getInfo (data) {
  return service({
    url: '/es/resource/lib/edit/info',
    method: 'GET',
    params: data,
  })
}